var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQaQatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_22642)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#8D1B3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0V45H45.15L35.9812 42.4969L45.15 40.0031L35.9906 37.5L45.15 34.9969L35.9906 32.5031L45.15 30L35.9812 27.4969L45.15 25.0031L35.9906 22.5L45.15 19.9969L35.9906 17.5031L45.15 15L35.9812 12.4969L45.15 10.0031L35.9906 7.5L45.15 4.99687L35.9812 2.50313L45.1594 0H60Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_22642"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQaQatar);
export default __webpack_public_path__ + "static/media/qa Qatar.f34c67957f582d9b8df547edb9a5faf6.svg";
export { ForwardRef as ReactComponent };